export enum DesignModuleNodeConfigExitHandling {
  channelEnd = 'CHANNEL_END',
  endpoint = 'ENDPOINT',
  handOff = 'HAND_OFF',
  hangup = 'HANGUP',
  returnToPreviousInput = 'RETURN_TO_PREVIOUS_INPUT',
  returnToPreviousModule = 'RETURN_TO_PREVIOUS_MODULE',
  returnToRootModule = 'RETURN_TO_ROOT_MODULE',
  subdialogReturn = 'SUBDIALOG_RETURN',
  transfer = 'TRANSFER'
}
